/* Pure variant selection shared with local regression tests. */
(function (root) {
  'use strict';
  function choose(variants, selected, index, value) {
    var wanted = selected.slice(); wanted[index] = value;
    var exact = variants.find(function(v) { return v.options.every(function(o,i) { return o === wanted[i]; }); });
    if (exact) return exact;
    var candidates = variants.filter(function(v) { return v.options[index] === value; });
    return candidates.sort(function(a,b) {
      function score(v) { return (v.available ? 100 : 0) + v.options.filter(function(o,i) { return o === wanted[i]; }).length; }
      return score(b) - score(a);
    })[0] || null;
  }
  function format(variant) {
    if (!variant) return null;
    var options = variant.options.join(' ');
    if (variant.requiresShipping === false || /קובץ|הורדה|digital|download|self.print/i.test(options)) return 'digital';
    if (/ממוסגר|framed/i.test(options)) return 'framed';
    if (/פוסטר|poster/i.test(options)) return 'poster';
    return 'canvas';
  }
  var api = {choose:choose, format:format};
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.OraytaVariants = api;
})(typeof window === 'object' ? window : this);
